export const MahaLogo = require("./logo.png");
export const MhLogo = require("./mh-logo.png");
export const India = require("./india-logo.jpg");
